import { CurrencyPipe, isPlatformBrowser, NgClass, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, PLATFORM_ID } from '@angular/core';
import { EffyButtonComponent, EffyButtonStyle } from '@effy-tech/angular-common/button';
import { EffyLiseretComponent } from '@effy-tech/angular-common/liseret';
import { ResponsiveSettings } from 'ngx-owl-carousel-o';
import { CarouselContainer } from '../../classes';
import { CarouselComponent } from '../carousel/carousel.component';
import { TitleComponent } from '../title/title.component';
import { IBlockCardsProduct } from './block-cards-product';

@Component({
  selector: 'nscf-block-cards-product',
  imports: [EffyLiseretComponent, TitleComponent, NgClass, EffyButtonComponent, NgOptimizedImage, CurrencyPipe, CarouselComponent],
  templateUrl: './block-cards-product.component.html',
  styleUrl: './block-cards-product.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'container',
  },
})
export class BlockCardsProductComponent extends CarouselContainer {
  @Input({ required: true }) data: IBlockCardsProduct;
  protected readonly buttonStyle = EffyButtonStyle.TERTIARY;
  private readonly platformId = inject(PLATFORM_ID);
  protected readonly isBrowser = isPlatformBrowser(this.platformId);

  protected readonly clickId = 'site_clic_bloc_produit';

  protected readonly responsiveSettings: ResponsiveSettings = {
    0: {
      items: 1,
    },
    375: {
      items: 2,
      margin: 16,
    },
    768: {
      items: 3,
      margin: 24,
    },
  };
}
